import { Component, OnInit ,ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewWillEnter,IonContent } from '@ionic/angular';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { EmployeeListService } from '../../../../common/services/employee-listing.service'; ///app/common/services/employee-list.service';

@Component({
  selector: 'app-customer-details-page',
  templateUrl: 'customer-details.page.html',
  styleUrls: [
    './customer-details.page.scss',
    '../../styles/customer-lookup.styles.scss'
  ]
})
export class CustomerDetailsPage implements ViewWillEnter, OnInit {
@ViewChild(IonContent) content!: IonContent;
  customerCode: string;

  rows: any;
  currentRoute: string;

  public loaded: boolean = false;

  customerParams: any;

  totalPages: number = 0;
  totalElements: number = 0;

  currPage: number;
  pageSize: number;

  public customerDetails: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: GtrakAuthService,
    private employeeListService: EmployeeListService,
  ) { 
    this.currentRoute = null;
  }

  ngOnInit(): void {
    if(!this.authService.user.canViewCustomerLookup) {
      this.router.navigate([this.authService.user.homeLocation]);
    }

    this.customerParams = new RequestParams();


    this.customerCode = this.route.snapshot.paramMap.get('code');

    this.currPage = 1;
  if( localStorage.getItem("pageSize")!=null){
        this.pageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.pageSize = 500;
   }

    
    this.rows = [];
    this.currentRoute = this.router.url;

    this.customerParams.setOrdering('lastName', 'asc');

    this.customerParams.filters.CustomerCode = this.customerCode;
    this.loaded = false;
    this.getCustomerDetails();
  }

  ionViewWillEnter(): void {
      if( localStorage.getItem("pageSize")!=null){
        this.pageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.pageSize = 500;
   }
  }



  async getCustomerDetails() {
    this.customerParams.setPaging(this.currPage, this.pageSize);
    var employees = await this.employeeListService.query(this.customerParams);
    this.totalElements = employees.totalRecords;
    this.totalPages = employees.totalPages;

    this.rows = employees.results;

    this.loaded = true; 
  }

async setPage(event: { pageNumber: number, pageSize:number ;sortField?: string, sortDirection?: string }): Promise<void> {
        this.loaded = false;
        
        this.pageSize=event.pageSize;
        this.currPage = event.pageNumber;
        if(event.sortField==""){
            this.customerParams.setOrdering('lastName', 'asc');
        }else{
        this.customerParams.setOrdering(event.sortField, event.sortDirection);
        }
        await this.getCustomerDetails();
          this.content.scrollToTop(500);
        this.loaded = true;
        }

}